import React, { useContext } from 'react';
import { formatCurrency } from '../../helpers/stringHelpers';
import { ReactComponent as RestoreIcon } from '../../images/icons/refresh.svg';
import { ButtonIcon, SecondaryButton } from '../../shared/Button';
import { FormContext } from '../../shared/form/Form';
import { Td, Tr } from '../../shared/Table';
import { useBillOfMaterialsPricingModelInfo } from './BillOfMaterialsContext';
import { BillOfMaterialsItemFormModel } from './billOfMaterialsItemFormModel';
import { ActionButtonTd, CurrencyTd } from './BillOfMaterialsItemsTable';
import { BillOfMaterialsUnitFormModel } from './billOfMaterialsUnitFormModel';
import { BillOfMaterialsPartsById, getPartPriceBasedOnCustomerType } from './dataForEditBillOfMaterialsForm';

type Props = {
  item: BillOfMaterialsItemFormModel;
  unit: BillOfMaterialsUnitFormModel;
  partsById: BillOfMaterialsPartsById;
  restoreItem: () => void;
  fieldName: string;
};

export const BillOfMaterialsRemovedItemField = ({ item, unit, partsById, restoreItem, fieldName }: Props) => {
  const { isUsingLegacyPricingModel, selectedCustomerTypeOption } = useBillOfMaterialsPricingModelInfo();
  const part = item.partId == null ? null : partsById[item.partId] || null;
  const { isDisabled } = useContext(FormContext);

  if (part == null) {
    return (
      <Tr>
        <Td />
        <Td>???</Td>
        <Td>{item.quantity}</Td>
        <Td>UNKNOWN PART</Td>
        <Td />
        <CurrencyTd>{item.costInPounds && formatCurrency(item.costInPounds)}</CurrencyTd>
        <CurrencyTd>{item.priceInPounds && formatCurrency(item.priceInPounds)}</CurrencyTd>
        <ActionButtonTd>
          <SecondaryButton onClick={restoreItem} title="Restore">
            <ButtonIcon>
              <RestoreIcon title="Restore" />
            </ButtonIcon>
          </SecondaryButton>
        </ActionButtonTd>
      </Tr>
    );
  }

  const partPrice = getPartPriceBasedOnCustomerType(isUsingLegacyPricingModel, part, selectedCustomerTypeOption);

  return (
    <Tr>
      <Td />
      <Td>{part.name}</Td>
      <Td>{item.quantity}</Td>
      <Td>{part.description}</Td>
      <Td>{unit.name}</Td>
      <CurrencyTd>
        {(item.costInPounds && formatCurrency(item.costInPounds)) ||
          (part.costInPounds && formatCurrency(part.costInPounds))}
      </CurrencyTd>
      <CurrencyTd>
        {(item.priceInPounds && formatCurrency(item.priceInPounds)) || (partPrice && formatCurrency(partPrice))}
      </CurrencyTd>
      <ActionButtonTd>
        {!isDisabled && (
          <SecondaryButton onClick={restoreItem} title="Restore">
            <ButtonIcon>
              <RestoreIcon title="Restore" data-testid={restoreBillOfMaterialsItemButtonTestId(fieldName)} />
            </ButtonIcon>
          </SecondaryButton>
        )}
      </ActionButtonTd>
    </Tr>
  );
};

export const restoreBillOfMaterialsItemButtonTestId = (fieldName: string) => `restore-bom-item-${fieldName}`;
